import * as React from 'react';
import { Switch, Route } from 'react-router';
import { AddUserDetail } from './AddUserDetail';
import { EditUserDetail } from './EditUserDetail';
import { UserDetailList } from './UserDetailList';

export class UserDetail extends React.Component<{}, {}> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route path='/dashboard/user_detail/add' component={AddUserDetail} />
        <Route path='/dashboard/user_detail/:id' component={EditUserDetail} />
        <Route exact path='/dashboard/user_detail' component={UserDetailList} />
      </Switch>
    );
  }
}
